module.exports = __webpack_public_path__ + "img/millennium.28529a1.svg";